import React, { useState } from 'react';
import uuid from 'uuid-random';
import { Spinner } from 'react-magma-dom';
import { CloudDownloadIcon } from 'react-magma-icons';
import { ErrorDownloadModal } from '../Modal/ErrorDownloadModal';
import { StyledEngagementPromptsButton } from '../Styled/StyledTextType';
import { StyledButtonSpinnerWrapper } from '../Styled/StyledWrappers';
import { getStageColors, handleDownloadFile } from '../../utils';
import { BookType, Stage } from '../../types/exemplars';
import { COLORS } from '../../constants';
import { IAsset } from '../../constants/assets';
import { ENGAGEMENT_PROMPTS_COLORS } from '../../constants/engagementPrompts';

interface IEngagementPrompts {
  engagement: IAsset;
  stage: string;
  level: string;
  isFullWidth: boolean;
}

export const EngagementPrompts = (props: IEngagementPrompts): JSX.Element => {
  const { engagement, stage, level, isFullWidth } = props;

  const {
    title,
    links: { self },
  } = engagement;

  const [isLoading, setIsLoading] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const colors = ENGAGEMENT_PROMPTS_COLORS[stage.toLowerCase() as Stage][level as BookType];
  const { main: mainColor } = getStageColors(stage.toLowerCase());

  const openErrorModal = () => {
    setIsErrorModalOpen(true);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  const onDownload = () => {
    !isLoading && handleDownloadFile(title, self, setIsLoading, openErrorModal);
  };

  if (engagement === null) return <></>;

  return (
    <>
      <StyledEngagementPromptsButton
        hoverFontColor={COLORS.seaBlue}
        color={COLORS.seaBlue}
        BGColor={colors.main}
        hoverColor={colors.hover}
        isFullWidth={isFullWidth}
        key={uuid()}
        onClick={onDownload}
        disabled={isLoading}
        data-testid="engagements-prompts"
        aria-label="engagement prompts download"
      >
        {title}
        {isLoading ? (
          <StyledButtonSpinnerWrapper margin="0px 0 0px 12px" height="32.6px" width="32.6px">
            <Spinner color={COLORS.seaBlue} size={21.2} />
          </StyledButtonSpinnerWrapper>
        ) : (
          <CloudDownloadIcon size={32.6} />
        )}
      </StyledEngagementPromptsButton>
      {isErrorModalOpen && (
        <ErrorDownloadModal
          mainColor={mainColor}
          onCloseClick={closeErrorModal}
          onRetryClick={() => {
            closeErrorModal();
            onDownload();
          }}
        />
      )}
    </>
  );
};
